import container from "../../libs/container/container";


const amdTermsOfUseContentModule = (function () {
    const name = 'terms-of-use__content-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    };


    view.startup = function () {

    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTermsOfUseContentModule;